import { render, staticRenderFns } from "./NotifySettings.vue?vue&type=template&id=7556e2a7&scoped=true"
import script from "./NotifySettings.vue?vue&type=script&lang=js"
export * from "./NotifySettings.vue?vue&type=script&lang=js"
import style0 from "./NotifySettings.vue?vue&type=style&index=0&id=7556e2a7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7556e2a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7556e2a7')) {
      api.createRecord('7556e2a7', component.options)
    } else {
      api.reload('7556e2a7', component.options)
    }
    module.hot.accept("./NotifySettings.vue?vue&type=template&id=7556e2a7&scoped=true", function () {
      api.rerender('7556e2a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/NotifySettings.vue"
export default component.exports